module.exports = __webpack_public_path__ + "static/img/bg7.a3f4d39a.png";